<script setup lang="ts">
import { computed } from 'vue';
import { useSessionStore } from '../../../stores';
import { PracticeDataType, PracticePostMessage, Session } from '../../../types/session';
import Iframe from '../../General/Iframe.vue';
import { useEventListener } from '@vueuse/core';

const sessionStore = useSessionStore()
const practiceUrl = computed<string | null>(() => sessionStore.practiceUrl[sessionStore.currentSession as Session.practice | Session.practice2])

function handlePostMessage(message: PracticePostMessage) {
    if (message.data.type !== PracticeDataType.update_item_info) return;

    sessionStore.setPracticeResult(message.data.result)
}

useEventListener(window, 'message', handlePostMessage)
</script>

<template>
    <div class="h-full flex flex-col items-center justify-evenly overflow-auto">
        <Iframe v-if="practiceUrl" :src="practiceUrl" />
    </div>
</template>